<template>
    <div class="card card-body text-start mb-3 cuerpoDetalle">
        <h5 class="card-title">MOP's {{ tipoCuentas }}</h5>
        <BarChart
            :chartData="mopsData"
            width="100px"
            height="100px"
            :options="options"
        />
    </div>    
</template>

<script>
import { defineComponent } from 'vue'
import { LineChart, BarChart } from 'vue-chart-3';
import { DoughnutChart, useDoughnutChart } from "vue-chart-3";
import { Chart, ChartData, ChartOptions, registerables } from "chart.js";

Chart.register(...registerables);

export default defineComponent({
    name: 'GraficaMops',

    props: {
        //Inicio CCD-0003
        tipoCuentas: String,
        cuentas: Array,
        mopsMaximos: Array,
        mopsActuales: Array
        //Fin CCD-0003
    },

    components: {
        LineChart,
        BarChart
    },

    setup(props) {
        const mopsData = {
            labels:  props.cuentas,//CCD-0003
            datasets: [
                {
                 //Se elimina gráfico de ratios CCD-0003
                    label: 'Mora máxima',
                    data: props.mopsMaximos,//CCD-0003
                    fill: false,
                    //borderColor: 'rgb(0,32,96)',
                    backgroundColor: 'rgba(48, 45, 116, 1)',
                    borderRadius: 10,
                    tension: 0,
                    datalabels: {
                        color: '#FFF',
                        backgroundColor: 'rgba(48, 45, 116, 1)',
                        align: 'center',
                        labels: {
                            title: {
                                font: {
                                    size: '12px',
                                    weight: 'bold'
                                }
                            }
                        }
                    }
                    //showLine: false
                },
                {
                    label: 'Mora actual o última',
                    data: props.mopsActuales,//CCD-0003
                    fill: false,
                    // borderColor: 'rgb(237,125,49)',
                    backgroundColor: 'rgba(255, 160, 0, 1)',
                    borderRadius: 10,
                    tension: 0,
                    datalabels: {
                        color: '#FFF',
                        backgroundColor: 'rgba(255, 160, 0, 1)',
                        
                        align: 'center',
                        labels: {
                            title: {
                                font: {
                                    size: '12px',
                                    weight: 'bold'
                                }
                            }
                        }
                    }
                    // showLine: false
                }
            ]
        }
        const options = {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top',
                },
                title: {
                    display: true,
                    text: 'MOP´s',
                },
            },
            scales: {
                y: {
                    min: 0,
                    max: 10,
                }
            },
        };

        return { mopsData, options }
    },
})
</script>
